const config = {
  REGION: "us-east-1",
  USER_POOL_ID: "us-east-1_uaG8GWj6M",
  USER_POOL_APP_CLIENT_ID: "46ogounf0vf8hbuvb4anj3nfs6",
};

export default config;
